import eanCode from './ean-code'
import referenceNumber from './reference-number'
import meterNumber from './meter-number'
import indexValue from './index-value'
import greaterThan from './greater-than'
import gsmNumber from './gsm-number'
import landlineNumber from './landline-number'
import maxDigits from './max-digits'
import onlyLetters from './only-letters'
import reCaptcha from './re-captcha'
import noAccents from './no-accents'
import noSpecialCharsEmail from './no-special-chars-email'

export default {
  eanCode,
  referenceNumber,
  meterNumber,
  indexValue,
  greaterThan,
  gsmNumber,
  maxDigits,
  onlyLetters,
  landlineNumber,
  reCaptcha,
  noAccents,
  noSpecialCharsEmail
}
